<template>
    <van-tabs v-model="activeName" @click="onClick">
        <van-tab title="到期订购套餐" name="0">
            <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o" :scrollable="false" wrapable>
                设置自动续费之后，无需手动充值每个月会自动买套餐，不过需要购买余额哦
            </van-notice-bar>
            <van-field readonly clickable name="picker" :value="value"  label="套餐续费" placeholder="点击选择套餐续费" @click="showPicker = true"  />
            <van-popup v-model="showPicker" position="bottom">
                <van-picker
                    title=""
                    show-toolbar
                    :columns="columns"
                    @confirm="onConfirm"
                    @cancel="onCancel"
                />
            </van-popup>
            <van-field clickable name="picker" v-model="password"  label="密码" placeholder="请输入密码" />
            <van-button type="info" size="normal" block round @click="sumbit">提交</van-button>
        </van-tab>
        <van-tab title="流量用完订购套餐" name="1">
            <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o" :scrollable="false" wrapable>
                设置自动续费之后，无需手动充值每个月会自动买套餐，不过需要购买余额哦
            </van-notice-bar>
            <van-field readonly clickable name="picker" :value="value"  label="套餐续费" placeholder="点击选择套餐续费" @click="showPicker = true"  />
            <van-popup v-model="showPicker" position="bottom">
                <van-picker
                    title=""
                    show-toolbar
                    :columns="columns"
                    @confirm="onConfirm"
                    @cancel="onCancel"
                />
            </van-popup>
            <van-field clickable name="picker" v-model="password"  label="密码" placeholder="请输入密码" />
            <van-button type="info" size="normal" block round @click="sumbit">提交</van-button>
        </van-tab>
        <van-tab title="设置查询" name="3">
            <div class="fl-clex">
                <div class="top">
                    <div class="title">自动续费设置信息</div>
                </div>
                <van-divider />
                <div class="content">
                    <div class="name">流量用完订购套餐：<span>{{dataObj.addPkgName}}</span></div>
                    <div class="name">到期订购套餐：<span>{{dataObj.xuPkgName }}</span></div>
                    <div class="name">续费状态：<span>{{dataObj.isAuto === 0 ? '开启' : '关闭' }}</span></div>
                </div>
            </div>
            <van-button type="info" size="normal" block round @click="sumbitType">{{dataObj.isAuto === 0 ? '关闭' : '开启'}}续费状态</van-button>
        </van-tab>
    </van-tabs>
</template>
<script>
import {wxRequest} from '@/api/user.js' 
import { Toast } from 'vant';
export default {
    data() {
        return {
            showPicker:false,
            activeName: 'c',
            value:"",
            password:'',
            checked:false,
            form:{
                poolType:'0'
            },
            dataObj:{},
            columns: [],
        };
    },
    created(){
        if (this.$route.query.iccid) {
            localStorage.setItem("iccid",this.$route.query.iccid)
        }
        this.init('0')
    },
    methods:{
        onClick(e){
            this.init(e)
            this.value = ''
            this.form.id = ''
            this.form.poolType = e
        },
        init(e){
            var params = {
                iccid:localStorage.getItem("iccid"),
                poolType:e
            }
            wxRequest("sim/select/auto/manager", params, "post").then(res => {
                if(res.data.code === '200'){
                    if(e === '0' || e === '1'){
                        this.columns = res.data.data.map(item=>{
                            item.text=item.name
                            return item
                        })
                    }else{
                        this.dataObj =res.data.data
                    }
                }else{
                    Toast.fail(res.data.message);
                }
            })
        },
        sumbit(){
            if(!this.form.id){
                Toast.fail('请选择套餐数据');
                return
            }
            if(!this.password){
                Toast.fail('请输入密码');
                return
            }
            var params = {
                iccid:localStorage.getItem("iccid"),
                id:this.form.id,
                payPass:this.password,
                poolType:this.form.poolType
            }
            wxRequest("sim/update/auto/manager", params, "post").then(res => {
                if(res.data.code === '200'){
                    Toast.fail(res.data.message);
                }else{
                    Toast.fail(res.data.message);
                }
            })
        },
        sumbitType(){
            var params = {
                iccid:localStorage.getItem("iccid"),
                cardState:this.dataObj.isAuto === 1 ? 0 : 1
            }
            wxRequest("sim/update/auto/state", params, "post").then(res => {
                if(res.data.code === '200'){
                    Toast.success('操作成功');
                    this.init('3')
                }else{
                    Toast.fail(res.data.message);
                }
            })
        },
        onConfirm(e){
            this.value = e.name
            this.form.id = e.id
            this.onCancel()
        },
        onCancel(){
            this.showPicker = false
        }
    }
};
</script>
<style lang="less" scoped>
.van-tabs{
    height: 100%;
    ::v-deep .van-tabs__wrap{
        border-bottom: 1px solid #e7e7e7;
    }
    ::v-deep .van-tabs__content{
        padding:14px;
        height:calc(100% - 74px);
        .van-tab__pane{
            height: 100%;
        }
    }
}
.van-cell{
    align-items: center;
    height: 60px;
    border-bottom: 1px solid #e7e7e7;
}
.van-button{
    margin-top:20px;
}
.fl-clex{
    width:90%;
    padding:10px;
    border-radius: 10px;
    box-shadow: 0px 2px 4px rgba(136, 136 ,136,.2);
    margin-bottom: 10px;
    .top{
        display: flex;
        justify-content: space-between;
        .title{
            font-size:16px;
            font-weight: 500;
        }
    }
    .content{
        .name{
            line-height: 24px;
            font-size:14px;
            color: #222;
            font-family: PingFangSC-Medium, PingFang SC;
            span{
                font-size: 13px;
                color: #666;
                color: #75c7ff;
            }
        }
    }
}
</style>